// extracted by mini-css-extract-plugin
export var button = "Button-module--button--b8976";
export var dangerous = "Button-module--dangerous--65a93";
export var disabled = "Button-module--disabled--24d54";
export var large = "Button-module--large--5ddd5";
export var secondary = "Button-module--secondary--c6ecc";